import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const Alert = ({ message, type }) => {
    const alertStyles = {
        error: {
            container: 'bg-white border-l-4 border-brand-terracotta',
            iconColor: 'text-brand-terracotta',
            icon: faExclamationCircle,
        },
        success: {
            container: 'bg-white border-l-4 border-brand-lime',
            iconColor: 'text-brand-lime',
            icon: faCheckCircle,
        },
    };

    const style = alertStyles[type] || alertStyles.error;

    return (
        <div className={`p-4 rounded-md shadow-sm flex items-center ${style.container}`}>
            <FontAwesomeIcon icon={style.icon} className={`${style.iconColor} mr-3 text-xl`} />
            <p className="text-gray-800 font-medium">{message}</p>
        </div>
    );
};

export default Alert;
